
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medicine-dictionary/search",
      function () {
        return require("private-next-pages/medicine-dictionary/search/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/medicine-dictionary/search"])
      });
    }
  